import { Phone, PhoneOff, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { VapiCallStatus } from './useVoiceClient'

interface Props {
  status: VapiCallStatus
  onConnect: () => void
  onDisconnect: () => void
}

const stateColors: Record<VapiCallStatus, string> = {
  idle: 'bg-text-muted',
  connecting: 'bg-warning',
  connected: 'bg-success',
  disconnecting: 'bg-warning',
  error: 'bg-error',
}

export function VapiConnectionControls({ status, onConnect, onDisconnect }: Props) {
  const { t } = useTranslation('calls')
  const isConnected = status === 'connected'
  const isTransitioning = status === 'connecting' || status === 'disconnecting'

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <span className={`h-2.5 w-2.5 rounded-full ${stateColors[status]} ${isTransitioning ? 'animate-pulse' : ''}`} />
        <span className={`text-sm font-medium ${isConnected ? 'text-success' : status === 'error' ? 'text-error' : 'text-text-secondary'}`}>
          {t(`voiceTest.connection.${status}`)}
        </span>
      </div>

      {!isConnected ? (
        <button
          onClick={onConnect}
          disabled={isTransitioning}
          className="flex items-center gap-2 rounded-lg bg-success/90 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-success disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isTransitioning ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Phone className="h-4 w-4" />
          )}
          {t('voiceTest.connection.connect')}
        </button>
      ) : (
        <button
          onClick={onDisconnect}
          className="flex items-center gap-2 rounded-lg bg-error/90 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-error"
        >
          <PhoneOff className="h-4 w-4" />
          {t('voiceTest.connection.disconnect')}
        </button>
      )}
    </div>
  )
}
